import { REF } from "./ref-baselines";

// Return 0 if value is null/undefined/NaN
const isNum = (v: any) => Number.isFinite(Number(v));

export const over = (v?: number, r?: number) => {
  if (!isNum(v) || !isNum(r)) return 0;
  const vv = Number(v), rr = Math.max(Number(r), 1e-6);
  return Math.max(0, (vv - rr) / rr);
};

export const under = (v?: number, r?: number) => {
  if (!isNum(v) || !isNum(r)) return 0;
  const vv = Number(v), rr = Math.max(Number(r), 1e-6);
  return Math.max(0, (rr - vv) / rr);
};

export const phDeviation = (ph?: number) => {
  if (!isNum(ph)) return 0;
  const p = Number(ph);
  const lo = REF.ph.lo, hi = REF.ph.hi;
  if (p < lo) return (lo - p) / 1.5;
  if (p > hi) return (p - hi) / 1.5;
  return 0;
};

export const round2 = (x: number) => Math.round(x * 100) / 100;
export { REF };
